import "./es.object.assign-7e79fd7b.js";
import "./es.parse-int-d7709701.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.string.starts-with-a6645e0a.js";
import { zIndices as v } from "@ucl/shared-component-foundations";
var r = {
  dropdown: {
    topAndBottom: 8,
    leftAndRight: 0
  },
  tooltip: {
    topAndBottom: 18,
    leftAndRight: 18
  },
  popuptip: {
    topAndBottom: 20,
    leftAndRight: 20
  },
  datepicker: {
    topAndBottom: 8,
    leftAndRight: 0
  }
}, w = function(t, i, a, e) {
  var n, o = parseInt(e == null || (n = e.height) == null ? void 0 : n.replace("px", ""), 10), l = "";
  a === "dropdown" ? l = t.top - r[a].topAndBottom - o + "px" : a === "datepicker" ? l = t.top - r[a].topAndBottom - i.height + 28 + "px" : l = t.top - r[a].topAndBottom - i.height + "px";
  var p = t.width + "px", u = t.left + 50 * t.width / 100 + "px", d = t.bottom + r[a].topAndBottom + "px", h = t.left - i.width - r[a].leftAndRight + "px", f = t.left + t.width + r[a].leftAndRight + "px", c = t.top + t.height / 2 + "px";
  return {
    calculateTop: l,
    calculateLeft: u,
    calculateTopBottom: d,
    calculateLeftRight: h,
    calculateRight: f,
    topPosition: c,
    calculateDropdownWidth: p
  };
}, x = function(t, i, a, e, n) {
  var o = {}, l = w(i, a, e, n), p = l.calculateTop, u = l.calculateLeft, d = l.calculateTopBottom, h = l.calculateLeftRight, f = l.calculateRight, c = l.topPosition, m = l.calculateDropdownWidth;
  return t.startsWith("top") && (o = {
    top: p,
    left: u,
    bottom: "unset",
    right: "unset"
  }), t.startsWith("bottom") && (o = {
    top: d,
    left: u,
    right: "unset"
  }), t.startsWith("left") && (o = {
    top: c,
    left: h,
    right: "unset",
    bottom: "unset"
  }), t.startsWith("right") && (o = {
    top: c,
    left: f,
    bottom: "unset"
  }), t === "down_left" && (o = {
    top: d,
    left: i.left + "px"
  }), t === "down_right" && (o = {
    top: d,
    left: i.right - a.width + "px"
  }), t === "up_left" && (o = {
    top: p,
    left: i.left + "px",
    bottom: "unset"
  }), t === "up_right" && (o = {
    top: p,
    left: i.right - a.width + "px",
    bottom: "unset"
  }), e === "dropdown" && (o = Object.assign({}, o, {
    width: m
  })), o;
}, _ = function(t, i, a, e) {
  var n;
  if (!t.current || !i.current)
    return {};
  var o = (n = t.current) == null ? void 0 : n.querySelector('[data-trigger="true"]'), l = o ? o.getBoundingClientRect() : t.current.getBoundingClientRect(), p = i.current.getBoundingClientRect(), u = getComputedStyle(i.current), d = x(a, l, p, e, u), h = {
    tooltip: void 0,
    popuptip: void 0,
    dropdown: 9e3,
    datepicker: "" + v.dropdown
  };
  return Object.assign({}, d, {
    zIndex: h[e]
  });
};
export {
  _ as g
};
